export const teamData = [
    {
        id: 1,
        name: "Sidra Afzal",
        position: "Advocate High Court + CEO",
        company: "SA Visa Consultancy",
        image: "/Sidra Afzal.jpeg",
        email: "savisaconsultant080@gmail.com",
        phone: "+968 9524 9020",
        description: "Leading SA Visa Consultancy with expertise in legal advisory, career planning, international education and visa consulting"
    },
    {
        id: 2,
        name: "Fareeha Kamal",
        position: "Expert Educational Advisor, IELTS and PTE Instructor",
        company: "SA Visa Consultancy",
        image: "/Fareeha Kamal .png",
        email: "fareehadaughterofkamal@gmail.com",
        phone: "03092529209",
        description: "Expert educational advisor and IELTS/PTE instructor with extensive experience in test preparation and student guidance"
    },
    {
        id: 3,
        name: "Dr Aqsa Afzal",
        position: "Marketing Manager",
        company: "SA Visa Consultancy",
        image: "/Dr Aqsa Afzal.png",
        email: "infosavisaconsultant@gmail.com",
        phone: "0309 9702678",
        description: "Strategic marketing leader driving brand growth and client engagement for SA Visa Consultancy"
    },
    {
        id: 4,
        name: "Mohammed Saleem",
        position: "General Manager",
        company: "SA Visa Consultancy",
        image: "/Mohammed saleem.png",
        email: "saleemandar2@gmail.com",
        phone: "+96898937149",
        description: "Overseeing daily operations and ensuring excellence in service delivery across all departments"
    }
];
